// biome-ignore lint/correctness/noUnusedImports: Bulk suppression as part of biome migration
import React, { type PropsWithChildren } from 'react'

import { cn } from '@/utils/shadcn/utils'

interface ContainerProps extends PropsWithChildren {
  className?: string
}

export const ChartContainer = ({ children }: ContainerProps) => (
  <div className="w-full bg-background rounded-[6px]">{children}</div>
)

export const HeaderContainer = ({ children }: ContainerProps) => (
  <div className="py-3 px-4">{children}</div>
)

export const HeaderContent = ({ children, className }: ContainerProps) => (
  <div className={cn('flex items-center justify-between mb-[14px]', className)}>
    {children}
  </div>
)

export const SwitchContainer = ({ children }: ContainerProps) => (
  <div className="max-w-[150px]">{children}</div>
)
